const BASE = `${process.env.PUBLIC_URL || ""}/brand`;

export const LogoMark = ({ size = 32, className = "" }) => (
  <img src={`${BASE}/cresqen-mark-160.png`} alt="CRESQEN" width={size} height={Math.round(size * 0.85)} className={`object-contain select-none ${className}`} draggable={false} />
);

export const Logo = ({ size = 32, showWord = true, testId = "cresqen-logo" }) => (
  <div className="flex items-center gap-2.5" data-testid={testId}>
    <LogoMark size={size} />
    {showWord && <img src={`${BASE}/cresqen-wordmark-420.png`} alt="CRESQEN" style={{ height: Math.round(size * 0.42) }} className="select-none" draggable={false} />}
  </div>
);

export const BrandLoader = ({ label = "Loading", testId = "brand-loader" }) => (
  <div data-testid={testId} className="min-h-screen bg-[#050816] flex flex-col items-center justify-center gap-5">
    <LogoMark size={64} className="animate-pulse" />
    <div className="font-mono text-[11px] tracking-[0.2em] uppercase text-[#7C8BAD]">{label}…</div>
  </div>
);
